import type { IDailyStat, IMockupLogsPayload } from './types';

/** Build sorted daily series; if API returns only top-level aggregates, synthesize one row. */
export function normalizeDaily(payload: IMockupLogsPayload, fallbackDate: string): IDailyStat[] {
  if (Array.isArray(payload.daily) && payload.daily.length > 0) {
    return [...payload.daily].sort((a, b) => a.statDate.localeCompare(b.statDate));
  }
  if (payload.sessionStats?.length && payload.eventStats) {
    return [
      {
        statDate: fallbackDate,
        sessionStats: payload.sessionStats,
        eventStats: payload.eventStats,
      },
    ];
  }
  return [];
}
